import http from "./http-common";
import { getAuthToken } from "./authService";

// Per-user tutorial history: who passed which tour. The catalogue itself lives
// in src/tutorials/registry.js — the server only stores what the user did.

const authHeaders = async () => ({ Authorization: `Bearer ${await getAuthToken()}` });

const getState = async () => {
  const response = await http.get("/api/v1/tutorials/state", { headers: await authHeaders() });
  return response.data;
};

const markTutorial = async (tutorialId, status, version) => {
  const response = await http.put(
    `/api/v1/tutorials/state/${encodeURIComponent(tutorialId)}`,
    { status, version },
    { headers: await authHeaders() }
  );
  return response.data;
};

const setPreferences = async (suppressPrompts) => {
  const response = await http.put(
    "/api/v1/tutorials/preferences",
    { suppressPrompts },
    { headers: await authHeaders() }
  );
  return response.data;
};

/** Admin only: completed / skipped counts per tutorial. */
const getStats = async () => {
  const response = await http.get("/api/v1/tutorials/stats", { headers: await authHeaders() });
  return response.data;
};

/** Admin only: who completed / skipped which tutorial, newest activity first. */
const getProgress = async () => {
  const response = await http.get("/api/v1/tutorials/progress", { headers: await authHeaders() });
  return response.data;
};

const TutorialService = { getState, markTutorial, setPreferences, getStats, getProgress };

export default TutorialService;
